import "../assets/css/Login.css";
import { MdSettingsInputAntenna } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useState } from "react"; 
import axios from "axios";
import { API_URL } from "../config";

function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");


  const handleLogin = async () => {
    setError(""); 

    try {
      const response = await axios.post(`${API_URL}/api/login_check`, {
        email: email,
        password: password
      });

      const data = response.data;

      if (data.token) {
        localStorage.setItem("token", data.token);

        try {
          const payload = JSON.parse(atob(data.token.split(".")[1]));
          const roles = payload.roles || [];

          if (roles.includes("ROLE_ADMIN")) {
            navigate("/admin");
          } else {
            navigate("/wifi-form");
          }
        } catch (decodeError) {
          console.error("Erreur de décodage du token", decodeError);
          setError("Erreur lors de la lecture des droits utilisateur.");
        }
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || "Identifiants invalides.");
      } else {
        setError("Impossible de contacter le serveur.");
      }
    }
  };


  return (
  <div className="page">
    <div className="box">

      <div className="box-icon">
      
       <MdSettingsInputAntenna color="#7b70d8" size={30} />

      </div> 
      

      <h1 className="titleConnect">Connectez-vous à votre espace</h1>

      {error && <p style={{ color: "#d85a30", fontSize: "13px", marginBottom: "12px" }}>{error}</p>}

      <div className="field-group">
        <label className="field-label">Email</label>
        <div className="input-wrapper">
          <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="M2 7l10 7 10-7" />
          </svg>
          <input
            type="email"
            placeholder="admin@azurinfo.fr"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>

      <div className="field-group">
        <label className="field-label">Mot de passe</label>
        <div className="input-wrapper">
          <svg viewBox="0 0 24 22" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="11" width="8" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
          </svg>
          <input
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
      </div>

      <button className="btn_seConnecter" onClick={handleLogin}>
        Se connecter
      </button>

    </div>
  </div>
);

}

export default Login;